import { useTranslation } from "react-i18next";
import type { PlatformTypeName } from "@multi-chat/shared";
import { ChannelIdentityBadge } from "../../components/channel/ChannelIdentityBadge.js";
import { channelLabelI18nKey } from "../../components/channel/channel-presentation.js";

export function LinkedPlatformBadges({
  types,
}: {
  types: PlatformTypeName[];
}): React.JSX.Element {
  const { t } = useTranslation();

  if (types.length === 0) {
    return <span className="text-muted">—</span>;
  }
  return (
    <span className="inline-flex items-center gap-1">
      {types.map((type) => (
        <ChannelIdentityBadge
          key={type}
          platformType={type}
          size="table"
          label={t(`channel.${channelLabelI18nKey(type)}`)}
        />
      ))}
    </span>
  );
}
